import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { isChunkError, recarregarPorChunk } from "./lib/chunkRecarrega";

// Chunk antigo que sumiu no deploy, quando o erro escapa por fora do React —
// o caminho de dentro é o lazyRetry, e os dois compartilham o controle de
// recarregamento em lib/chunkRecarrega.
function talvezRecarregar(msg: unknown) {
  if (isChunkError(msg)) recarregarPorChunk();
}
window.addEventListener("error", (e) => talvezRecarregar(e.message));
window.addEventListener("unhandledrejection", (e) => talvezRecarregar(e.reason?.message ?? e.reason));

createRoot(document.getElementById("root")!).render(<App />);
